export const SECTIONS = [
  { id: "s1", title: "1. Client details" },
  { id: "s2", title: "2. Business structure" },
  { id: "s3", title: "3. Geographic reach & sites" },
  { id: "s4", title: "4. Registration groups" },
  { id: "s5", title: "5. Restrictive practices" },
  { id: "s6", title: "6. High intensity supports" },
  { id: "s7", title: "7. Participant cohorts" },
  { id: "s8", title: "8. Existing documents" },
  { id: "s9", title: "9. Timeline & commercial" },
];

export const EMPTY = {
  org_name: "", abn: "", contact_name: "", contact_phone: "", contact_email: "",
  discovery_date: "", target_registration_date: "",
  entity_type: "", workforce_model: "", worker_count: 0, ahpra_regulated: "",
  states: [], site_types: [],
  registration_groups: [],
  rp_regulated: "", bsp_develop: "", bsp_implement: "",
  high_intensity: [],
  cohorts: [],
  documents_held: [],
  timeline_driver: "", prepared_4_6_weeks: "", aqa_budgeted: "",
};
